import React from "react";
import { TableCell, TableRow, Typography, Box } from "@mui/material";
import PropTypes from "prop-types";
import { TRANSFER_COLOR, VALUE_FONT_WEIGHT, NEGATIVE_COLOR, POSITIVE_COLOR } from "../../Constants";
import { useSelector } from "react-redux";
import { selectWalletById } from "../../store/walletSlice";
import WalletIcon from "../layout/WalletIcon";
import { selectCurrencies } from "../../store/currencySlice";
import {useTranslation} from "react-i18next";

const TransactionTransfer = ({ transaction, onClick }) => {
    const {t} = useTranslation();
    const description = transaction.description || t("common.transactionType.transfer");
    const valueFrom = transaction.valueFrom ?? transaction.valueTo;
    const valueTo = transaction.valueTo ?? transaction.valueFrom;
    const walletFrom = useSelector((state) => selectWalletById(state, transaction.walletFrom));
    const walletTo = useSelector((state) => selectWalletById(state, transaction.walletTo));
    const currencies = useSelector(selectCurrencies) || [];
    const currencyFrom = walletFrom?.currency != null
        ? currencies.find((c) => c.id === walletFrom.currency || c.id == walletFrom.currency)
        : null;
    const currencyTo = walletTo?.currency != null
        ? currencies.find((c) => c.id === walletTo.currency || c.id == walletTo.currency)
        : null;
    const hasDifferentCurrencies =
        currencyFrom?.id != null &&
        currencyTo?.id != null &&
        currencyFrom.id !== currencyTo.id;
    const formatWithCurrency = (val, currency) =>
        currency?.shortName ? `${val} ${currency.shortName}` : String(val);

    const isDraft = transaction?.state === "DRAFT";

    return (
        <TableRow
            key={transaction.id}
            className={isDraft ? "Draft" : undefined}
            sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
            onClick={(event) => onClick(transaction)}
        >
            <TableCell padding="none" align="center" sx={{ width: 56 }}>
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 0.5 }}>
                    {walletFrom && <WalletIcon image={walletFrom.image} sx={{ fontSize: 24 }} />}
                    {walletTo && <WalletIcon image={walletTo.image} sx={{ fontSize: 24 }} />}
                </Box>
            </TableCell>
            <TableCell component="th" scope="row">
                <Typography variant="body1">{description}</Typography>
            </TableCell>
            <TableCell align="right">
                {hasDifferentCurrencies ? (
                    <>
                        <Typography variant="body1" sx={{ color: NEGATIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                            −{formatWithCurrency(valueFrom, currencyFrom)}
                        </Typography>
                        <Typography variant="body1" sx={{ color: POSITIVE_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                            +{formatWithCurrency(valueTo, currencyTo)}
                        </Typography>
                    </>
                ) : (
                    <Typography variant="body1" sx={{ color: TRANSFER_COLOR, fontWeight: VALUE_FONT_WEIGHT }}>
                        {formatWithCurrency(valueFrom, currencyFrom || currencyTo)}
                    </Typography>
                )}
            </TableCell>
        </TableRow>
    );
};

TransactionTransfer.propTypes = {
    transaction: PropTypes.shape({
        id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        description: PropTypes.string,
        valueFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        valueTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }).isRequired,
    onClick: PropTypes.func.isRequired,
};

export default TransactionTransfer;
